<script setup>
import { Icon, Button } from "@components"

import Prompt from '@utils/Prompt'

import { useRoute } from 'vue-router'
const route = useRoute()

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()


import { useSettings } from '@store/settings'
const $settings = useSettings()

// import { isLg, isXl } from '@utils/mediaQuery'

const pageTitle = () => {
    return route.meta.title || ''
}

// const saveSettings = async () => {
//     await $settings.saveSettings('customizer')
//     console.log('Settings saved')
//     $customizer.isCustomizerChanged = false
//     Toast.success('Customizer updated successfully')
// }
</script>

<template>
    <div class="h-[76px] border-b border-[#EAECF0] py-[18px] pr-8 pl-[22px] flex items-center justify-between bg-white" :style="`padding-left:${$customizer.sidebarWidth}`">
        <div class="flex items-center gap-5 text-[#101828] text-lg font-semibold" :class="{ 'pl-5': !$settings.isRTL }">{{ pageTitle() }}</div>

        <div class="flex gap-3 items-center" :class="{ 'pl-5': $settings.isRTL }">
            <Button size="lg" type="tertiary_gray" radius="square" class="text-[#475467]" @click="$customizer.resetCustomizer">
                <Icon name="repeat04" size="20px" class="text-[#F79009]"></Icon> Reset
            </Button>
            <!-- <Button size="lg" type="secondary_gray" radius="square">Live Preview</Button> -->
            <Button size="md" type="primary" radius="square" @click="$customizer.publish">Update Form</Button>
        </div>
    </div>
</template>